export default "__VITE_ASSET__BsG$HlXP__"